import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./DashboardBottomCard.module.scss";
import arrowUpIcon from "../../../assets/images/icons/arrow-up-green.svg";
import arrowDownIcon from "../../../assets/images/icons/arrow-down-red.svg";

interface IDashboardBottomCardProps {
  title: string;
  value: number;
  percentValue: number;
  percentValueType: "up" | "down";
}

const DashboardBottomCard: React.FC<IDashboardBottomCardProps> = ({
  title,
  value,
  percentValue,
  percentValueType,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`${styles.wrapper} ${percentValueType === "up" ? styles.upDecor : styles.downDecor}`}
    >
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.text}>{t("NumberOfClients")}</p>
      <div className={styles.description}>
        <p>{value}</p>
        <div className={`${percentValueType === "up" ? styles.up : styles.down}`}>
          {percentValue}%
          {percentValueType === "down" ? (
            <img src={arrowDownIcon} alt={"down"} />
          ) : (
            <img src={arrowUpIcon} alt={"up"} />
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardBottomCard;
